import PropTypes from "prop-types";

import { t } from "../../../../services";
import { strCode } from "../../../../consts";

import { FlexContainers, SmallButton, WrapperContainer } from "../../../../components";

export const SectionControlButtons = ({
  isPrevDisabled,
  isFinish,
  loading,
  onSetActiveStep = () => {},
  onFinish = () => {}
}) => {
  return (
    <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={8} width={"100%"} height={"100%"}>
      <SmallButton
        secondary
        disabled={isPrevDisabled || loading}
        onClick={() => onSetActiveStep(-1)}>
        {t(strCode.PREVIOUS_BTN)}
      </SmallButton>

      {isFinish ? (
        <SmallButton
          onClick={onFinish}
          loading={loading}
          disabled={loading}
          style={{ minWidth: "124px" }}>
          {t(strCode.FINISH_BTN)}
        </SmallButton>
      ) : (
        <SmallButton onClick={() => onSetActiveStep(1)}>{t(strCode.NEXT_BTN)}</SmallButton>
      )}
    </WrapperContainer>
  );
};

SectionControlButtons.propTypes = {
  isPrevDisabled: PropTypes.bool,
  isFinish: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  onSetActiveStep: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired
};
